/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export {
  APP_LOAD_ERROR_EXIT_ACTION_ID,
  APP_LOAD_ERROR_RELOAD_ACTION_ID,
  buildAppLoadErrorActions,
  buildSosErrorActions,
  getAppLoadErrorMessage,
  getAppLoadErrorTitle,
  getSosErrorMessage,
  getSosErrorTitle,
  SOS_ERROR_CODE
} from "./appLoadErrorActions";
export {
  AppLoadErrorRecovery,
  exitAppFromLoadError,
  logAppLoadError,
  planAppLoadErrorRecovery,
  reloadAppFromLoadError,
  runSilentAppRecovery
} from "./appLoadErrorRecovery";
export type { TAppLoadErrorRecovery } from "./appLoadErrorRecovery";
